<script>
export default {
  name: 'CreatorLink',
  props: {
    news: {
      type: Object,
    },
  },
  computed: {
    isUser() {
      return !this.news.textParams[0].includes('org');
    },
    creatorId() {
      return this.isUser ? this.news.textParams[0] : this.news.textParams[0].split('/')[1];
    },
  },
};
</script>

<template>
  <router-link
    v-if="isUser"
    :to="{name: 'userpage', params: {type: 'profile', id: creatorId}}"
  >{{news.textParams[1]}}</router-link>
  <router-link
    v-else
    :to="{name: 'OrganizationView', params: {id: creatorId}}"
  >{{news.textParams[1]}}</router-link>
</template>

<style scoped>

</style>
